import * as Sentry from '@sentry/react';
import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../sass/style.scss';
import {
  RouterProvider,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { getLogRocketSessionURL, identifyUser } from './app/utils/logrocket';
import { routes } from './routes/Router';

Sentry.init({
  dsn: window.SENTRY_DSN,
  release: window.COMMIT_SHA,
  environment: window.APP_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Optional replay configuration can go here
      // For example: maskAllText: false, blockAllMedia: false
    }),
  ],
  // Performance monitoring
  tracesSampleRate: 0.1,
  // Session Replay sampling rates - these go at the root level in v8+
  replaysSessionSampleRate: 0.1, // Capture 10% of all sessions
  replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors
  beforeSend(event, _hint) {
    // Add LogRocket session URL to Sentry events for better integration
    const logRocketSessionURL = getLogRocketSessionURL();
    if (logRocketSessionURL) {
      event.extra = event.extra || {};
      event.extra.logRocketSessionURL = logRocketSessionURL;
    }
    return event;
  },
});

const appNode = document.getElementById('react-app');

// Initialize LogRocket with existing user if available
const user = window.__USER__ || null;
if (user && user.id) {
  identifyUser(user.id, {
    name: user.name,
    email: user.email,
  });
}

if (appNode) {
  const root = createRoot(appNode);
  root.render(
    <StrictMode>
      <RouterProvider router={routes} />
    </StrictMode>
  );
}
